module.exports = __webpack_public_path__ + "img/resource-tech-image-56.4e98372e.jpg";